module.exports = __webpack_public_path__ + "static/media/mail.b7855dcf.svg";